import request from '@/utils/request';
export const defaultSchemeData = {
  id: 0,
  enabled: true,
  name: '',
  startDate: '',
  endDate: '',
  image: null
};
export const getSchemes = params => request({
  url: '/schemes',
  method: 'get',
  params
});
export const getSchemeById = id => request({
  url: `/schemes/${id}`,
  method: 'get'
});
export const updateScheme = (id, data) => request({
  url: `/schemes/${id}`,
  method: 'patch',
  data
});
export const deleteScheme = id => request({
  url: `/schemes/${id}`,
  method: 'delete'
});
export const createScheme = data => request({
  url: '/schemes',
  method: 'post',
  data
});